
import { defineComponent, Ref, ref, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'

import {StateType as VerifyEmailStateType} from './store'

import {gotoEmail, emailList} from '@/utils/gotoemail'

interface ActivationSetupData {
    t: (key: string | number) => string;
    isflag: Ref<boolean>;
    isShow: Ref<boolean>;
    email: Ref<string>;
    isBtn: Ref<boolean>;
    handleBack: (type: string) => void;
    handleGoToEmail: (e: MouseEvent) => void;
    handleClose: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'Activation',
    setup(): ActivationSetupData {
        const { t } = useI18n()
        const route = useRoute()
        const router = useRouter()
        const store = useStore<{verifyemail:VerifyEmailStateType}>()
        const email = ref<string>(String(localStorage.getItem('regEmail')) ?? '')
        const isflag = ref<boolean>(true)
        const isShow = ref<boolean>(true)
        const isBtn = ref<boolean>(true)

        const handleBack = (type:string) => {
            if(type == 'login'){
                router.replace('/user/login')
            }else{
                router.replace('/user/register')
            }
        }

        const handleGoToEmail = () => {
            const emSuffix = `@${email.value?.split('@')[1]}`
            gotoEmail(emSuffix)
        }

        const routeParams = () => {
            if(route?.query?.u&&route?.query?.k&&route?.query?.t){
                isflag.value = false
                const k = route?.query?.k ?? ''
                const t = route?.query?.t ?? ''
                const u = route?.query?.u ?? ''
                const params = {
                    email: email.value,
                    emailKey: k,
                    type: t,
                    userCode: u
                }
                verifyemailFn(params)
            }
        }

        const verifyemailFn = async(params:any) => {
            try {
                const res:boolean = await store.dispatch('verifyemail/verifyEmailFn',params)
                if(res){
                    isShow.value = res
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        const handleClose = (e:MouseEvent) => {
            router.replace('/user/login')
        }

        const rexEmail = () => {
            let val = `@${email.value?.split('@')[1]}`
            let flag = emailList[val]
            flag ? isBtn.value = true : isBtn.value = false
        }

        onMounted(()=>{
            routeParams()
            rexEmail()
        })

        onUnmounted(()=>{
            localStorage.removeItem('regEmail')
        })

        return {
            t,
            email,
            isflag,
            isShow,
            isBtn,
            handleBack,
            handleGoToEmail,
            handleClose
        }
    }
})
